import { Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Component, EventEmitter, Output } from '@angular/core';
import { ListBase } from '../../../../../core/_infrastructure/classes/listBase';
import { NotificationService } from '../../../../../core/_infrastructure/classes/services/notification.service';
import { proxiedPropertiesOf } from '../../../../../core/_infrastructure/types/utils';
import { VariedadPeriodoForm } from '../periodos-variedad.types';
import { ConfirmationService } from 'primeng/api';
import { DatosPeriodoViewModel } from '../../plazos/plazos.types';

@Component({
    selector: 'app-periodos-variedad-list',
    templateUrl: './periodos-variedad-list.component.html',
    styleUrls: ['./periodos-variedad-list.component.scss'],
})
export class PeriodosVariedadListComponent extends ListBase implements OnInit, OnChanges {
    @Input() variedadesDePeriodo: VariedadPeriodoForm[];
    @Input() datosPeriodo: DatosPeriodoViewModel;
    @Input() esPeriodoFinalizado = false;
    @Input() esVigenteConSolicitudes: boolean = false;
    @Output() delete = new EventEmitter<number>();

    cols: any[];

    constructor(
        protected notificationService: NotificationService,
        private confirmationService: ConfirmationService,
    ) {
        super(notificationService);
    }

    ngOnInit(): void {
        this.initCols();
        this.loading = false;
    }

    private initCols(): void {
        const variedadPeriodo = proxiedPropertiesOf<VariedadPeriodoForm>();

        this.cols = [
            { field: 'Link', header: '' },
            { field: variedadPeriodo.Id?.toString(), header: 'Id', display: 'none' },
            { field: variedadPeriodo.Variedad?.toString(), header: 'Variedad' },
            { field: variedadPeriodo.NombreCientifico?.toString(), header: 'Nombre Científico' },
            { field: variedadPeriodo.CodigoEppo?.toString(), header: 'Código EPPO' },
            { field: variedadPeriodo.Grupo?.toString(), header: 'Grupo' },
            { field: variedadPeriodo.Forma?.toString(), header: 'Forma' },
        ];
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.variedadesDePeriodo?.currentValue) {
            this.variedadesDePeriodo = [...changes.variedadesDePeriodo.currentValue];
            this.loading = false;
        }
    }

    onDelete(rowIndex: number): void {
        if (rowIndex === undefined) {
            return;
        }

        if (this.variedadesDePeriodo[rowIndex].MarkToDelete) {
            this.delete.emit(rowIndex);
            return;
        }

        this.confirmationService.confirm({
            message: 'Se va a eliminar la Variedad del Periodo ¿Está seguro?.',
            accept: () => {
                this.delete.emit(rowIndex);
            },
        });
    }

    showDeleteButton(rowData: VariedadPeriodoForm): boolean {
        if (this.esPeriodoFinalizado) {
            return false;
        }
        if (this.esVigenteConSolicitudes && rowData.Id && (!rowData?.MarkToDelete || rowData?.MarkToDelete === undefined)) {
            return false;
        }
        return !rowData?.MarkToDelete || rowData?.MarkToDelete === undefined;
    }
}
